export enum AccountDeletionReason {
  NotUsingEnough = 'not_using_enough',
  PrivacyConcerns = 'privacy_concerns',
  TechnicalIssues = 'technical_issues',
  MissingFeatures = 'missing_features',
  FoundAlternative = 'found_alternative',
  CFBMember = 'cfb_member',
  Other = 'other',
}

export const ACCOUNT_DELETION_REASON_LABELS: Record<AccountDeletionReason, string> = {
  [AccountDeletionReason.NotUsingEnough]: 'I am not using the app enough',
  [AccountDeletionReason.PrivacyConcerns]: 'I have privacy concerns',
  [AccountDeletionReason.TechnicalIssues]: 'I experienced technical issues or bugs',
  [AccountDeletionReason.MissingFeatures]: 'The app is missing features I need',
  [AccountDeletionReason.FoundAlternative]: 'I found a better alternative',
  [AccountDeletionReason.CFBMember]: 'I am a Climate First Bank member and no longer need the app',
  [AccountDeletionReason.Other]: 'Other',
}

export const ACCOUNT_DELETION_REASON_LIST = Object.values(AccountDeletionReason)

export type DeleteAccountPayload = {
  email: string
  reasons: AccountDeletionReason[]
  details: string
  otherReason?: string
}

export function isValidAccountDeletionReason(value: unknown): value is AccountDeletionReason {
  return typeof value === 'string' && ACCOUNT_DELETION_REASON_LIST.includes(value as AccountDeletionReason)
}

export function normalizeEmailForComparison(email: string): string {
  return email.trim().toLowerCase()
}

export function emailsMatch(entered: string, accountEmail: string): boolean {
  return normalizeEmailForComparison(entered) === normalizeEmailForComparison(accountEmail)
}
